import * as React from 'react';

export interface LogoProps {
  className?: string;
  color?: string;
}

const getColor = (color: any) => {
  switch (color) {
    case "dark": return "#231F20";
    case "light": return 'white';
    case "red": return '#F4514D';
    default: return 'white';
  }
};

export const Logo: React.FC<LogoProps & React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    className={props.className}
    width={48}
    height={20}
    viewBox="0 0 48 20"
    {...props}
  >
    <path fill={getColor(props.color)} d="M4.2 7.65v5.38c0 1.96 0.34 2.42 2.14 2.42 0.55 0 2.16-0.03 2.51-0.03l-0.63 3.55c-0.32 0-1.82 0.03-2.4 0.03C1.05 19 0 17.75 0 13.11V0.65L4.2 0v4.1H9L8.37 7.65H4.2z"/>
    <path fill={getColor(props.color)} d="M15.14 19H11V9.62C11 5.34 12.98 4 16.88 4c1.01 0 1.87-0.03 3.12 0.06l-0.62 3.68c-0.31-0.03-1.27-0.06-2.08-0.06 -1.9 0-2.16 0.71-2.16 2.42V19z"/>
    <path fill={getColor(props.color)} d="M34 16.06c0 2.23-0.8 2.94-3.04 2.94h-4.71C22.3 19 21 17.34 21 14.51v-0.6c0-3.17 1.76-4.51 5.41-4.51 1.78 0 2.77 0.34 3.49 0.77V9.86c0-1.57-0.35-2.34-2.66-2.34 -1.2 0-3.44-0.03-5.01 0.06l0.61-3.51C23.88 4.03 25.45 4 27.5 4 31.95 4 34 5.51 34 9.4V16.06zM25.08 14.26c0 1.12 0.48 1.57 1.97 1.57h2.82v-1.66c0-1.17-0.4-1.72-2.29-1.72h-0.37c-1.68 0-2.13 0.43-2.13 1.6V14.26z"/>
    <path fill={getColor(props.color)} d="M47.95 4.06l-0.64 3.59C46.09 7.56 45.46 7.56 44 7.56c-2.2 0-2.73 0.46-2.73 3.19v1.51c0 2.73 0.58 3.19 2.73 3.19 1.51 0 2.54 0.03 4-0.06l-0.64 3.56c-1.41 0.03-2.7 0.06-3.47 0.06C38.7 19 37 17.15 37 12.26v-1.51C37 5.88 38.83 4 43.84 4 44.79 4 45.93 3.98 47.95 4.06"/>
  </svg>
);

export default Logo;